<h4>{{ 'profiles.view.custom-fields' | translate | titlecase }}</h4>
<div class="custom-fields-container mct-flex mct-row mct-wrap" >
  <div *ngFor="let field of profileCustomFields; let i = index" class="custom-field custom-field-50pct" >
    <div class="card-field-label">{{ field.FieldName }}</div>
    <div class="custom-field-value">
      <div [innerHTML]="field.FieldValue | linky"></div>
    </div>
    <div *ngIf="i / 2 < rowCount - 1" class="row-divider"></div>
  </div>
</div>
